// ********************************************************************************************************************
// 后台管理主页
const Background = () => import('views/bg/Background')

// 后端系统
const AdminGateway = () => import('views/bg/backend/AdminGateway')
const AdminDubbo = () => import('views/bg/backend/AdminDubbo')
const AdminSpringCloud = () => import('views/bg/backend/AdminSpringCloud')
const AdminBackendLog = () => import('views/bg/backend/AdminBackendLog')
const NginxLog = () => import('views/bg/backend/AdminAccessLog')
const AdminRuntimeLog = () => import('views/bg/backend/AdminRuntimeLog')

export default {
  path: '/bg/backend',
  redirect: '/bg',
  name: 'Backend',
  title: '后端系统',
  icon: 'el-icon-loading',
  component: Background,
  meta: { needAuth: true, roles: ['tnb_admin'] },
  children: [
    {
      path: '/bg/backend/gateway',
      name: 'Gateway',
      component: AdminGateway,
      title: '网关路由',
      icon: 'el-icon-loading',
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/backend/springcloud_service',
      name: 'SpringCloudService',
      title: 'SpringCloud服务',
      icon: 'el-icon-loading',
      component: AdminSpringCloud,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/backend/dubbo_service',
      name: 'DubboService',
      title: 'Dubbo服务',
      icon: 'el-icon-loading',
      component: AdminDubbo,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/backend/access_log',
      name: 'AccessLog',
      title: '访问日志',
      icon: 'el-icon-loading',
      component: NginxLog,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/backend/runtime_log',
      name: 'RuntimeLog',
      title: '运行日志',
      icon: 'el-icon-loading',
      component: AdminRuntimeLog,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/backend/realtime_log',
      name: 'Realtime',
      title: '实时日志',
      icon: 'el-icon-loading',
      component: AdminBackendLog,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    }
  ]
}
